import ButtonImageSliced from '../ButtonImageSliced.js';
import { Colors } from '../../consts/Colors.js';
import SliderA2 from './SliderA2.js';
import { A2Data } from '../../consts/Data.js';

export default class Part3 extends Phaser.GameObjects.Container {
    constructor(scene, partData, screenManager) {
        super(scene, 0, 0, []);
        scene.add.existing(this);
        this.scene = scene;
        this.partData = partData
        this.sliderData = A2Data.sliderCtnt
        this.step = 0
        this.screenManager = screenManager
        this.allBullets = []
        this.allBullets2 = []
        this.scene.addSounds()

        this.screenData = this.partData[this.step];

        this.partContainer = this.scene.add.container(1920, 0);
        this.add(this.partContainer);

        this.slider = new SliderA2(this.scene, this);
        // this.partContainer.add(this.slider)
        this.slider.setAlpha(0)
        this.add(this.slider)

        this.createNavButtons()
        this.buildBaseTexts()
        this.createMainImage()
        this.addBulletList()
        this.addMoreContent()
        this.animateIn(1)
    }

    changeScreen(i) {
        this.qcm?.destroy()
        this.screenData = this.partData[i];
        this.transitionOut(() => {
            this.createNavButtons()
            this.buildBaseTexts()
            this.createMainImage()
            this.addBulletList()
            if (i === 0) { this.addMoreContent() }
            if (i === 2) {
                this.addMoreContent()
                this.addBulletList2()
                this.nextBtn.setTextContent("Terminer")
                if (this.scene.game.data.level === 2) {
                    this.scene.game.data.level = 3
                }

            }
            this.animateIn(2)
        })
    }

    nextFunction() {
        switch (this.step) {
            case 0:
                this.step = 1
                this.transitionOut(() => {
                    this.makeMainScreen()
                    this.animateIn(3)
                })
                break;
            case 1:
                this.step = 2
                this.showMany(this.content3, this.image3, this.image4);
                this.hideMany(this.image2);
                break;
            case 2:
                this.step = 3;
                this.hideMany(this.image4, this.image, this.content, this.content2, this.content3);
                this.scene.tweens.add({
                    targets: [this.image3],
                    x: 480,
                    y: 760,
                    scale: 0.9,
                    duration: 400,
                    ease: 'Power2',
                    onComplete: () => {
                        this.showMany(this.content4, this.image5);
                    }
                });
                break;
            case 3:
                this.step = 4;
                this.showMany(this.content5, this.image6, this.image7);
                break;
            case 4:
                this.step = 5;
                this.setBulletsVisible(true);
                this.showMany(this.content6, this.image8);
                break;
            case 5:
                this.step = 6;
                this.showMany(this.content7);
                this.hideMany(this.content4, this.content5, this.content6, this.image3, this.image5, this.image6, this.image7, this.image8);
                this.setBulletsVisible(false);
                this.slider.setAlpha(1);
                this.scene.tweens.add({
                    targets: this.slider.sliderButton,
                    scale: 1.2,
                    duration: 600,
                    yoyo: true,
                    repeat: 5,
                    ease: 'Sine.easeInOut'
                })
                this.nextBtn.setAlpha(0);
                break;
            case 6:
                console.log("Create part 3 A2", this.screenData.title2.text)
                this.step = 7;
                if (this.slider) {
                    this.slider.finalStep();
                }
                this.scene.tweens.add({
                    targets: [this.slider],
                    x: 900,
                    y: 400,
                    duration: 400,
                    ease: 'Power2',
                    onComplete: () => {
                        this.hideMany(this.content7, this.title);
                        this.title.setText(this.screenData.title2.text);
                        this.showMany(this.content8, this.image9)
                        this.setBullets2Visible(true)
                    }
                });
                break;
            case 7:
                this.step = 8;
                this.slider.setAlpha(0)
                this.transitionOut(() => {
                    this.changeScreen(2);
                    // this.animateIn(4)
                })
                break;
            case 8:
                this.step = 0
                this.scene.scene.start('Menu')
                break

        }
    }
    previewFunction() {
        console.log(this.step)
        switch (this.step) {
            case 1:
                this.step = 0
                this.transitionOut(() => {
                    this.changeScreen(0)
                    this.animateIn(5)
                })
                break
            case 2:
                this.step = 1;
                this.hideMany(this.content3, this.image3, this.image4);
                this.showMany(this.image2);
                break;
            case 3:
                this.step = 2;
                this.hideMany(this.content4, this.image5);
                this.scene.tweens.add({
                    targets: [this.image3],
                    x: this.screenData.img3X,
                    y: this.screenData.img3Y,
                    scale: 1,
                    duration: 400,
                    ease: 'Power2',
                    onComplete: () => {
                        this.showMany(this.image4, this.image, this.content, this.content2, this.content3);
                    }
                });
                break;
            case 4:
                this.step = 3;
                this.hideMany(this.content5, this.image6, this.image7);
                break;
            case 5:
                this.step = 4;
                this.setBulletsVisible(false);
                this.hideMany(this.content6, this.image8);
                break;
            case 6:
                this.step = 5;
                this.hideMany(this.content7);
                this.showMany(this.content4, this.content5, this.content6, this.image3, this.image5, this.image6, this.image7, this.image8);
                this.setBulletsVisible(true);
                this.nextBtn.setAlpha(1);
                this.slider.setAlpha(0);
                this.slider.restartSlider();
                this.nextBtn.setAlpha(1);
                this.image3.x = 480
                this.image3.y = 760
                break;
            case 7:
                this.step = 6;
                this.hideMany(this.content8, this.image9)
                this.setBullets2Visible(false)
                if (this.slider) {
                    this.slider.finalReturn();
                }

                this.scene.tweens.add({
                    targets: [this.slider],
                    x: 736,
                    y: 409,
                    duration: 400,
                    ease: 'Power2',
                    onComplete: () => {
                        this.showMany(this.content7, this.title);
                        this.title.setText(this.screenData.title.text);

                    }
                });
                break;
            case 8:
                this.step = 7;
                this.transitionOut(() => {
                    this.slider.setAlpha(1)
                    this.makeMainScreen()
                    this.hideMany(this.content, this.content2, this.image, this.image2);
                    this.showMany(this.content8, this.image9)
                    this.setBullets2Visible(true)
                    this.animateIn(6)
                    // this.title.setText(this.screenData.title2.text);
                })
                break;
        }
    }

    endSlider() {
        this.nextBtn.setAlpha(1);
    }

    createNavButtons() {
        this.nextBtn = new ButtonImageSliced(this.scene, 1710, 990, 320, 80, "bouton", "Suivant");
        this.add(this.nextBtn);
        this.nextBtn.setClickFunction(() => this.nextFunction());
        if (this.step !== 0) {
            this.previewBtn = new ButtonImageSliced(this.scene, 220, 990, 320, 80, "bouton", "Précédent");
            this.add(this.previewBtn);
            this.previewBtn.setClickFunction(() => this.previewFunction());
        }
    }

    buildBaseTexts() {
        this.title = this.scene.createTextElement(this.screenData.title.titleX, this.screenData.title.titleY, this.screenData.title);
        this.partContainer.add(this.title);
        this.content = this.scene.createTextElement(this.screenData.content.contentX, this.screenData.content.contentY, this.screenData.content);
        this.partContainer.add(this.content);
    }

    addMoreContent() {
        this.content2 = this.scene.createTextElement(this.screenData.content2.content2X, this.screenData.content2.content2Y, this.screenData.content2);
        this.partContainer.add(this.content2);
    }

    addBulletList() {
        this.scene.createBulletList(this.screenData.bulletList, this.screenData.bulletX, this.screenData.bulletY, this.partContainer)
    }
    addBulletList2() {
        this.scene.createBulletList(this.screenData.bulletList2, this.screenData.bullet2X, this.screenData.bullet2Y, this.partContainer)
    }

    createMainImage() {
        this.image = this.scene.add.image(this.screenData.imgX, this.screenData.imgY, this.screenData.img).setOrigin(0.5);
        this.partContainer.add(this.image);
    }
    animateIn(step) {
        this.scene.playSound('whoosh');
        console.log("whoosh triggered step ", step);
        this.scene.tweens.add({
            targets: this.partContainer,
            x: 0,
            duration: 300,
            ease: 'Power2'
        });
    }

    transitionOut(onComplete) {
        // Remove nav buttons to avoid duplicate handlers
        this.nextBtn?.destroy();
        this.previewBtn?.destroy();
        this.scene.tweens.add({
            targets: this.partContainer,
            x: 1920,
            duration: 300,
            ease: 'Power2',
            onComplete: () => {
                this.partContainer.destroy();
                this.partContainer = this.scene.add.container(1920, 0);
                this.add(this.partContainer);
                onComplete && onComplete();
            }
        });
    }

    makeMainScreen() {
        this.screenData = this.partData[1];
        this.createNavButtons()

        this.title = this.scene.createTextElement(this.screenData.title.titleX, this.screenData.title.titleY, this.screenData.title);
        this.partContainer.add(this.title);

        this.content = this.scene.createTextElement(this.screenData.content.contentX, this.screenData.content.contentY, this.screenData.content);
        this.partContainer.add(this.content);

        this.content2 = this.scene.createTextElement(this.screenData.content2.content2X, this.screenData.content2.content2Y, this.screenData.content2);
        this.partContainer.add(this.content2);

        this.content3 = this.scene.createTextElement(this.screenData.content3.content3X, this.screenData.content3.content3Y, this.screenData.content3).setAlpha(0)
        this.partContainer.add(this.content3)

        this.content4 = this.scene.createTextElement(this.screenData.content4.content4X, this.screenData.content4.content4Y, this.screenData.content4).setAlpha(0)
        this.partContainer.add(this.content4)

        this.content5 = this.scene.createTextElement(this.screenData.content5.content5X, this.screenData.content5.content5Y, this.screenData.content5).setAlpha(0)
        this.partContainer.add(this.content5)

        this.content6 = this.scene.createTextElement(this.screenData.content6.content6X, this.screenData.content6.content6Y, this.screenData.content6).setAlpha(0)
        this.partContainer.add(this.content6)

        this.content7 = this.scene.createTextElement(this.screenData.content7.content7X, this.screenData.content7.content7Y, this.screenData.content7).setAlpha(0)
        this.partContainer.add(this.content7)

        this.content8 = this.scene.createTextElement(this.screenData.content8.content8X, this.screenData.content8.content8Y, this.screenData.content8).setAlpha(0)
        this.partContainer.add(this.content8)


        this.scene.createBulletList(this.screenData.bulletList, this.screenData.bulletX, this.screenData.bulletY, this.partContainer, false, null, this.allBullets)
        this.allBullets.forEach(bullet => {
            bullet.setAlpha(0)
        });

        this.scene.createBulletList(this.screenData.bulletList2, this.screenData.bullet2X, this.screenData.bullet2Y, this.partContainer, false, null, this.allBullets2)
        this.allBullets2.forEach(bullet => {
            bullet.setAlpha(0)
        });


        this.image = this.scene.add.image(this.screenData.imgX, this.screenData.imgY, this.screenData.img).setOrigin(0.5);
        this.partContainer.add(this.image);
        this.image2 = this.scene.add.image(this.screenData.img2X, this.screenData.img2Y, this.screenData.img2).setOrigin(0.5);
        this.partContainer.add(this.image2);
        this.image3 = this.scene.add.image(this.screenData.img3X, this.screenData.img3Y, this.screenData.img3).setOrigin(0.5).setAlpha(0)
        this.partContainer.add(this.image3);
        this.image4 = this.scene.add.image(this.screenData.img4X, this.screenData.img4Y, this.screenData.img4).setOrigin(0.5).setAlpha(0)
        this.partContainer.add(this.image4);
        this.image5 = this.scene.add.image(this.screenData.img5X, this.screenData.img5Y, this.screenData.img5).setOrigin(0.5).setAlpha(0)
        this.partContainer.add(this.image5);
        this.image6 = this.scene.add.image(this.screenData.img6X, this.screenData.img6Y, this.screenData.img6).setOrigin(0.5).setAlpha(0)
        this.partContainer.add(this.image6);
        this.image7 = this.scene.add.image(this.screenData.img7X, this.screenData.img7Y, this.screenData.img7).setOrigin(0.5).setAlpha(0)
        this.partContainer.add(this.image7);
        this.image8 = this.scene.add.image(this.screenData.img8X, this.screenData.img8Y, this.screenData.img8).setOrigin(0.5).setAlpha(0)
        this.partContainer.add(this.image8);
        this.image9 = this.scene.add.image(this.screenData.img9X, this.screenData.img9Y, this.screenData.img9).setOrigin(0.5).setAlpha(0)
        this.partContainer.add(this.image9);
    }
    setAlphaMany(list, alpha) { list.forEach(el => el && el.setAlpha(alpha)); }
    showMany(...els) { this.setAlphaMany(els, 1); }
    hideMany(...els) { this.setAlphaMany(els, 0); }
    setBulletsVisible(visible) { this.allBullets.forEach(b => b.setAlpha(visible ? 1 : 0)); }
    setBullets2Visible(visible) { this.allBullets2.forEach(b => b.setAlpha(visible ? 1 : 0)); }

}